import { render, staticRenderFns } from "./SubEmpresaBlocoDadosContratoOriginacaoAlvorada.vue?vue&type=template&id=455987b4&scoped=true&lang=pug"
import script from "./SubEmpresaBlocoDadosContratoOriginacaoAlvorada.vue?vue&type=script&lang=js"
export * from "./SubEmpresaBlocoDadosContratoOriginacaoAlvorada.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaBlocoDadosContratoOriginacaoAlvorada.vue?vue&type=style&index=0&id=455987b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455987b4",
  null
  
)

export default component.exports